export type ButtonVariant =
  | 'secondary'
  | 'danger'
  | 'transparent'
  | 'transparent-with-border'
  | 'light'
  | 'light-green'
  | 'light-greyish'
  | 'white'
  | 'green';

export interface ITableFooterActionButton {
  actionType: TableFooterActionButtonEnum;
  id: string;
  label: string;
  icon: string;
  buttonVariant?: ButtonVariant;
  isLoading?: boolean;
  loadingText?: string;
  iconColor?: string;
  isDisabled?: boolean;
}

export enum TableFooterActionButtonEnum {
  EXPORT = 'export',
  DELETE = 'delete',
  REMOVE = 'remove',
  IMPORT = 'import',
  CLOSE = 'close',
  ARCHIVE = 'archive',
  DOWNLOAD = 'download',
  SHARE = 'share',
  PRINT = 'print',
  EDIT = 'edit',
  CUSTOM = 'custom',
  CHANGE_STATUS = 'change status',
  CHANGE_STAGE = 'change stage',
  MARK_AS_OPEN = 'Open',
  MARK_AS_CLOSED = 'Complete',
  MARK_AS_READ = 'Mark Read',
  MARK_AS_UNREAD = 'Mark Unread',
  ASSIGNED_TAGS = 'Assigned Tags',
}

// New interface for the footer actions with object structure
export interface ITableFooterActions {
  [key: string]: ITableFooterActionButton;
}
